import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(""); setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) nav("/dashboard");
    else setErr(res.error);
  }
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white"
         data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src="/cesco-logo-landscape.png" alt="Cesco Equipment"
               className="w-64 max-w-full h-auto object-contain" />
        </div>
        <form onSubmit={onSubmit} className="bg-white rounded-2xl p-6 border border-[var(--cesco-border)] shadow-sm space-y-4">
          <h1 className="text-xl font-bold">Sign in</h1>
          <div>
            <label className="cesco-label">Email</label>
            <input className="cesco-input" type="email" value={email}
                   onChange={e=>setEmail(e.target.value)} autoFocus required
                   data-testid="login-email-input" />
          </div>
          <div>
            <label className="cesco-label">Password</label>
            <input className="cesco-input" type="password" value={password}
                   onChange={e=>setPassword(e.target.value)} required
                   data-testid="login-password-input" />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
          <button className="cesco-btn-primary w-full" disabled={loading} type="submit"
                  data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center text-sm">
            <Link to="/forgot-password" className="text-gray-600 hover:text-black"
                  data-testid="link-forgot">Forgot password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
